import React, { useEffect,useRef,useState } from 'react';
import AppStrings from '../../config/appstring';
import axios from 'axios';

function CancelForm({ onClose  ,studentData }) {
  const { RefNo, Amount, Term, Id,VouNo,SNo } = studentData;
  const [cancelReason, setCancelReason] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  console.log(studentData,'SSSSSSSSSSSSSSS');

  const handleCancel = async () => {

      const payload = {
        student: {
          REFNO: RefNo,
             ID: Id,
        FEESTYPE: Term,
           REMARK: cancelReason,
           VOUNO:VouNo,
          SNO:SNo,
          USERNAME:studentData.username
        },
      };
  
      try {
        //console.log('haiiii');
        //const res = await fetch("https://school.agnisofterp.com/agni/testing/entry", {
          const res = await fetch(AppStrings.CancelRefno, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
  
        const result = await res.json();
  
       alert(result.message || "Data saved successfully!");
  onClose();  


    //   handleCancel();   
    // onClose();   
    
    
    
        console.log('haiiii33');
      } catch (err) {
        console.error("Error:", err);
        alert("Failed to save data.");
      }
    };

const handleYesNo = () => {
  setShowConfirmModal(true);
};

  return (
        <div style={modalOverlayStyle}>
      <div style={{ ...modalStyle, position: 'relative' }}>
    <div style={formStyle}>
      <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'transparent',
            //background: 'red',
            border: 'none',
            fontSize: '30px',
            fontWeight: 'bold',
            cursor: 'pointer',
            color: '#888',
          }}
          aria-label="Close"
        >
          &times;
        </button>
      <h3>Delete Payment</h3>
<div style={formStyle1}>
  <div className="row">
        <div style={RightAlig} className="col-251">
      <label for="input" class="text">Student Id</label>  
        </div>
        <div className="col-751">
       <label for="input" class="text">{Id}</label>  
        </div>
      </div>

       <div className="row">
        <div style={RightAlig} className="col-251">
      <label for="input" class="text">Vou No</label>  
        </div>
        <div className="col-751">
       <label for="input" class="text">{VouNo}</label>  
        </div>
      </div>

       <div className="row">
        <div style={RightAlig} className="col-251">
      <label for="input" class="text">Term</label>  
        </div>
        <div className="col-751">
       <label for="input" class="text">{Term}</label>  
        </div>
      </div>

       <div className="row">
        <div style={RightAlig} className="col-251">
      <label for="input" class="text">Amount</label>  
        </div>
        <div className="col-751">
       <label for="input" class="text">{Amount}</label>  
        </div>
      </div>

       <div className="row">
        <div style={RightAlig} className="col-251">
      <label for="input" class="text">Ref No</label>  
        </div>
        <div className="col-751">
       <label for="input" class="text">{RefNo}</label>  
        </div>
      </div>
       <div className="row">
        <div style={RightAlig} className="col-251">
      <label for="input" class="text">SNo</label>  
        </div>
        <div className="col-751">
       <label for="input" class="text">{SNo}</label>  
        </div>
      </div>
<br></br>
      <label style={labelStyle}>Enter Reason</label>
      <input
        type="text"
        value={cancelReason}
        onChange={(e) => setCancelReason(e.target.value)}
        placeholder="Enter reason"
        style={inputStyle}
      />

      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <button style={buttonStyle} onClick={handleYesNo}>Delete</button>
      </div>
      </div>
    </div>
    </div>
    {showConfirmModal && (
  <div style={modalOverlayStyle}>
    <div style={{ ...modalStyle, width: '300px', textAlign: 'center' }}>
      <h3>Confirm Save</h3>
      <p>Are you sure you want to save this data?</p>
      <div style={{ marginTop: '15px' }}>
        <button
          onClick={() => {
            setShowConfirmModal(false);
            handleCancel(); // ✅ proceed with actual submission
          }}
        >
          Yes
        </button>
        <button
          onClick={() => setShowConfirmModal(false)}
          style={{ marginLeft: '10px' }}
        >
          No
        </button>
      </div>
    </div>
  </div>
)}
    </div>
    
  );
  
}




const RightAlig=
{
 fontWeight:'bold',
 color:'#2e71df'
}

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  width: '35%',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
   backgroundColor:'#fff0ce',
};

const formStyle = {
 
  width: '100%',
  maxWidth: '400px',
  margin: '0 auto',
  textAlign: 'center',
 
};
const formStyle1 = {
 

  textAlign: 'left',
  
};

const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  fontWeight: 'bold',
  
};

const inputStyle = {
  padding: '10px',
  fontSize: '14px',
  borderRadius: '4px',
  border: '1px solid #ccc',
  marginBottom: '20px',
  width:'100%'
};

const buttonStyle = {
  padding: '10px 20px',
  backgroundColor: '#e74c3c',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};


export default CancelForm;
